
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBox } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Padding extends Vue {
  @Prop()
  modelValue!: IFlexMessageBox

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBox) {
    this.$emit('update:modelValue', value)
  }

  get paddingList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  paddingValidate(val) {
    if (!val) return true

    const isPxOrPercent = /^(\d+(\.\d+)?)(px|%)$/.test(val)
    const isKeyword = this.paddingList.includes(val)
    return !(!isPxOrPercent && !isKeyword)
  }
}
